export default __webpack_public_path__ + "static/media/changeSchedule.5625de3c.svg";